import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TableUtil } from 'src/app/models/tableutil';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.css']
})
export class AttendanceComponent implements OnInit {

  constructor(public classmanager: ClassmanagementService, public toastr: ToastrService, public headerinfo: ComponentheaderService, public router: ActivatedRoute, public route: Router) {
    headerinfo.setHeaderDisplay('Lesson Attendance', [], []);

  }
  students: any
  meetingid: any
  lessondetails: any;
  meetingdetails: any;
  async ngOnInit() {
    let classid = this.router.snapshot.queryParams.classid;
    let meetingid = this.router.snapshot.queryParams.meetingid;
    let id = this.router.snapshot.queryParams.id
    this.headerinfo.pageLoadingStarted(this, false)
    this.lessondetails = await this.classmanager.getClassDetailsAbridged(classid).toPromise();
    this.meetingdetails = await this.classmanager.getLiveClassSchedule(id).toPromise();
    this.headerinfo.setHeaderDisplay("Lesson Attendance",
      [
        { displaytext: "Lesson", route: `/user/lesson`, params: { classid: classid } },
      ],
      []);
    this.students = await this.classmanager.getattendance(meetingid).toPromise().catch(err => { this.toastr.error(err); this.route.navigate(['/user/lesson'], { queryParams: { classid: classid } }); return; }).finally(() => this.headerinfo.pageLoadingDone(this));
    if (!this.students || this.students.length == 0) {
      this.toastr.error(`No attendance for ${this.lessondetails.title} on ${this.meetingdetails?.scheduleDateTimeString}`)
      this.route.navigate(['/user/lesson'], { queryParams: { classid: classid } });
    }
  }
  export() {
    if (this.students && this.students.length > 0) {
      const exceldata: Partial<any>[] = this.students.map(
        x => ({
          sno: x.AttendanceCount,
          name: x.Name,
        })
      );

      // TableUtil.exportArrayToExcel(exceldata, `${this.lessondetails.title}_${this.meetingdetails.scheduleDateTimeString}`);
      // TableUtil.exportArrayToExcel(exceldata, `${this.meetingdetails.scheduleDateTimeString}`);
      TableUtil.exportTableToExcel("attendance", `${this.lessondetails.title}`);
    }
    else {
      this.toastr.error("No data to export")
    }
  }
}
